enum AppLinkType {
	NONE = 0,
	ADMIN_ONLY = 1,
	IS_ROUTER = 2,
	VISIBLE_ON_LOGIN = 4,
	VISIBLE_ON_LOGOUT = 8,
	RESTRICTED_FOR_NPBE_ADMIN = 16
};

export default AppLinkType;